import { render, staticRenderFns } from "./ScreenSnitchPanel.vue?vue&type=template&id=8775075e&scoped=true&"
import script from "./ScreenSnitchPanel.vue?vue&type=script&lang=js&"
export * from "./ScreenSnitchPanel.vue?vue&type=script&lang=js&"
import style0 from "./ScreenSnitchPanel.vue?vue&type=style&index=0&id=8775075e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8775075e",
  null
  
)

export default component.exports